import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { ReviewCard } from '../shared/ReviewCard';
import { Reveal } from '../shared/Reveal';
import { SectionHeading } from '../shared/SectionHeading';
import { Stars } from '../shared/Stars';
import { useLanguage } from '../../contexts/LanguageContext';
import { business, reviewMeta } from '../../data/site';
export function ReviewsCarousel() {
  const {
    t
  } = useLanguage();
  const track = useRef<HTMLUListElement>(null);
  const items = reviewMeta.filter(r => r.onHome);
  const scroll = (dir: 1 | -1) => {
    const el = track.current;
    if (!el) return;
    el.scrollBy({
      left: dir * el.clientWidth * 0.9,
      behavior: 'smooth'
    });
  };
  return <section aria-labelledby="reviews-title" className="bg-white py-20 sm:py-24" data-id="element-64" data-mp="1x4lx1zzxnifr">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-65" data-mp="1x2ivcipf40v7">
        <Reveal data-id="element-66" data-mp="21vvl4w5u2dpj">
          <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-67" data-mp="21wddhhpdk7s6">
            <div data-id="element-68" data-mp="2jm7sh8nm5r5a">
              <div className="mb-4 flex items-center gap-3" data-id="element-69" data-mp="2jlplpi3bruj4">
                <Stars count={5} label={t.common.starsLabel} size="md" data-id="element-70" data-mp="2emuvhv3133oz" />
                <span className="text-sm text-ink/65" data-id="element-71" data-mp="2tazi3a57bzd1">
                  {business.rating.toFixed(1)} · {t.reviews.page.summary}
                </span>
              </div>
              <SectionHeading id="reviews-title" title={t.home.reviews.title} data-id="element-72" data-mp="2oiy9by78sqrr" />
            </div>
            <div className="flex items-center gap-2" data-id="element-73" data-mp="329uoam88x9gc">
              <button type="button" onClick={() => scroll(-1)} aria-label={t.home.reviews.prev} className="flex h-12 w-12 items-center justify-center rounded-full border border-petal text-mauve-deep transition-colors duration-150 ease-smooth hover:bg-petal/60" data-id="element-74" data-mp="2yau7f99bwgvz">
                <ChevronLeftIcon className="h-5 w-5" data-id="element-75" data-mp="1hw2r3upgj031" />
              </button>
              <button type="button" onClick={() => scroll(1)} aria-label={t.home.reviews.next} className="flex h-12 w-12 items-center justify-center rounded-full border border-petal text-mauve-deep transition-colors duration-150 ease-smooth hover:bg-petal/60" data-id="element-76" data-mp="1cy1797k7iwqi">
                <ChevronRightIcon className="h-5 w-5" data-id="element-77" data-mp="3m209g38um28a" />
              </button>
            </div>
          </div>
        </Reveal>

        <ul ref={track} className="no-scrollbar -mx-5 mt-10 flex snap-x snap-mandatory gap-5 overflow-x-auto scroll-px-5 px-5 pb-2 sm:mx-0 sm:scroll-px-0 sm:px-0" tabIndex={0} aria-label={t.home.reviews.title} data-id="element-78" data-mp="3vyd1kwoqw80x">
          {items.map(review => <li key={review.id} className="w-[85%] shrink-0 snap-start sm:w-[calc(50%-10px)] lg:w-[calc(33.333%-14px)]" data-id="element-79" data-mp="dkdjk1cirsfj">
              <ReviewCard review={review} data-id="element-80" data-mp="igu8gxrjmato" />
            </li>)}
        </ul>

        <Link to="/reviews" className="group mt-8 inline-flex items-center gap-2 text-sm font-medium text-mauve" data-id="element-81" data-mp="nib6mlin7j6k">
          {t.home.reviews.viewAll}
          <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-smooth group-hover:translate-x-1" data-id="element-82" data-mp="smcaaqnktytz" />
        </Link>
      </div>
    </section>;
}